export const theme = {
  telemovil: {
    logo: "./img/telemovil.png",
    productName: "telemovil",
    year: 2020,
  },
  trendme: {
    logo: "./img/trendme.png",
    productName: "trendme",
    year: 2021,
  },
  "fun-box": {
    logo: "./img/funbox.svg",
    productName: "fun-box",
    year: 2024,
  },
  mobioviewtv: {
    logo: "./img/MobioviewTV.svg",
    productName: "mobioviewtv",
    year: 2025,
  },
  vidflixz: {
    logo: "./img/vidflixz.png",
    productName: "vidflixz",
    year: 2021,
  },
  flamilingo: {
    logo: "./img/flamilingo.png",
    productName: "flamilingo",
    year: 2021,
  },
  "fitness-bay": {
    logo: "./img/fitness-bay.png",
    productName: "fitness-bay",
    year: 2022,
  },
  mobiofit: {
    logo: "./img/logo/mobiofitlogo.svg",
    productName: "Mobiofit",
    year: 2020,
  },
  mobiotube: {
    logo: "./img/mobitube-logo.svg",
    productName: "Mobiotube",
    year: 2026,
  },
  videoflux: {
    logo: "./img/videoflux-logo.png",
    productName: "Videoflux",
    year: 2026,
  },
  funoriva: {
    logo: "./img/funoriva-logo.svg",
    productName: "Funoriva",
    year: 2026,
  },
  mobiofitplus: {
    logo: "./img/logo/mobiofitlogo.svg",
    productName: "Mobiofitplus",
    year: 2021,
  },
  mobiofitpro: {
    logo: "./img/logo/mobiofitpro.svg",
    productName: "Mobiofitpro",
    year: 2026,
  },
  fitshouse: {
    logo: "./img/logo/FitsHouse_Logo.svg",
    productName: "fitshouse",
    year: 2026,
  },
};

export const getDomainTheme = () => {
  const product = window.location.hostname.split(".")[1];

  const defaultTheme = {
    logo: "./img/logo.png",
    productName: "MobioTV",
    year: 2019,
  };
  return theme[product] || defaultTheme;
};



// WEBPACK FOOTER //
// ./src/constants/theme.js